import React from "react";
import { Typography, Divider, Box } from "@mui/material";
import { Notice } from "../models/notice";
import {useParams} from "react-router-dom";
import {useGetNotice} from "../states/notice/server";

interface NoticeDetailPageSpec {
    propNotice?: Notice;
}

export const NoticeDetailPage: React.FC<NoticeDetailPageSpec> = ({ propNotice }) => {
    const { id } = useParams<{ id: string }>()
    const { data: fetchedNotice } = useGetNotice(id ?? '')

    if (!propNotice && !fetchedNotice) {
        return <></>;
    }

    const notice = propNotice ?? fetchedNotice!;

    return (
        <Box className={'fullscreen'} sx={{ padding: 2, maxWidth: 800, margin: "0 auto" }}>
            <Typography variant="h5" component="h1" gutterBottom>
                {notice.title}
            </Typography>

            <Typography variant="body2" color="text.secondary" gutterBottom>
                작성일: {new Date(notice.createdAt).toLocaleDateString()}
            </Typography>

            <Divider sx={{ marginY: 2 }} />

            <Typography variant="body1" component="p">
                {notice.body.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </Typography>
        </Box>
    );
};